// This filter transform will remove the openTok publisher from the locally persisted state.
// The publisher object has looping data structures whish break serialization.
// TODO: Real fix would be not to include the publisher in redux at all.
import _ from 'lodash'

export default function filterOpenTokPublisher(inboundState) {
  const filteredState = _.cloneDeep(inboundState)
  _.unset(filteredState, 'opentok.publisher')
  return filteredState
}
